// src/plugins/access.js
import store from '@/state/store'

export default {
    install(app) {
        app.config.globalProperties.$access = (permName) =>
            store.getters['permissions/hasPermission'](permName)
    }
}
